<script setup lang="ts">
import type { DropdownMenuItemEmits, DropdownMenuItemProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { DropdownMenuItem, useForwardPropsEmits } from "reka-ui"
import { cn } from "@/lib/utils"

const props = withDefaults(defineProps<DropdownMenuItemProps & {
  class?: HTMLAttributes["class"]
  /** Leaves room on the left for the indicator column of checkbox/radio siblings. */
  inset?: boolean
  /** `destructive` for an item that deletes or discards — the one colour change a menu makes. */
  variant?: "default" | "destructive"
}>(), { variant: "default" })
const emits = defineEmits<DropdownMenuItemEmits>()

const delegatedProps = reactiveOmit(props, "class", "inset", "variant")

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DropdownMenuItem
    v-bind="forwarded"
    :data-variant="variant"
    :class="cn(
      'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2.5 py-1.5 text-sm outline-none transition-colors data-[highlighted]:bg-accent-lighter data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:shrink-0',
      variant === 'destructive' && 'text-destructive data-[highlighted]:bg-destructive/10',
      inset && 'pl-8',
      props.class,
    )"
  >
    <slot />
  </DropdownMenuItem>
</template>
